var dropdownToggles = [].slice.call(document.querySelectorAll('.dropdown-toggle'));
var dropdownEles = dropdownToggles.map(function (dropdownEle) {
  dropdownEle.addEventListener('click', function(evt){
    /* close all active dropdowns within parent */
    var parentEle = evt.target.parentElement.parentElement;
    parentEle.childNodes.forEach(e => e.classList.remove('show'));
    /* toggle selected dropdown */
    var toggleState = evt.target.parentElement.classList.toggle('show');
    evt.target.parentElement.setAttribute('aria-expanded', toggleState);
  });

  dropdownEle.addEventListener('mouseover', function(evt){

    /* close all active dropdowns within parent */
    var parentEle = evt.target.parentElement.parentElement;
    parentEle.childNodes.forEach(e => e.classList.remove('show'));
    /* toggle selected dropdown */
    var toggleState = evt.target.parentElement.classList.toggle('show');
    evt.target.parentElement.setAttribute('aria-expanded', toggleState);
  });

  dropdownEle.parentElement.addEventListener('mouseleave', function(evt){

    /* close all active dropdowns within parent */
    var parentEle = evt.target.parentElement;
    parentEle.childNodes.forEach(e => e.classList.remove('show'));
    /* toggle selected dropdown */
    var toggleState = evt.target.classList.remove('show');
    evt.target.setAttribute('aria-expanded', false);
  });

});

var tabToggles = [].slice.call(document.querySelectorAll('.--tabs button.tab-link'));
var tabTogglesEles = tabToggles.map(function (tabEle) {
  tabEle.addEventListener('click', function(evt){
    var targetEle = evt.target;
    if( evt.target.hasAttribute('src') ){ targetEle = evt.target.parentElement; }
    /* close all active tabs within parent */
    var parentEle = targetEle.parentElement.parentElement;
    var childNodes = Array.prototype.slice.call(parentEle.children);
    childNodes.forEach(e => e.getElementsByTagName('button')[0].classList.remove('active') );
    
    /* toggle selected dropdown */
    var toggleState =targetEle.classList.toggle('active');
    targetEle.setAttribute('aria-selected', toggleState);

    var tabContentTarget = targetEle.getAttribute('aria-controls');
    var tabContent = document.getElementById(tabContentTarget);
    var tabParentElements = Array.prototype.slice.call(tabContent.parentElement.children);
    /* close all active tabs within parent */
    tabParentElements.forEach(e => e.classList.remove('active'));
    tabContent.classList.add('active');

    if( tabContent.querySelectorAll('.content-compare').length > 0 ){
      initContentCompare();
    }
  });
});

var accordionToggles = [].slice.call(document.querySelectorAll('.--accordion .accordion-button'));
var accordianTogglesEles = accordionToggles.map(function (accoridonEle) {
  accoridonEle.addEventListener('click', function(evt){

    if( !evt.target.classList.contains('on-click') ) {
      if( evt.target.classList.contains('active') ) {
        var toggleState = evt.target.classList.toggle('active');
        evt.target.setAttribute('aria-selected', toggleState);
      } else {
        /* close all active tabs within parent */
        var parentEle = evt.target.parentElement.parentElement;
        var childNodes = Array.prototype.slice.call(parentEle.children);
        childNodes.forEach(e => (!e.classList.contains('always-open'))?e.querySelector('.accordion-button').classList.remove('active'):'' );
        
        /* toggle selected dropdown */
        var toggleState = evt.target.classList.toggle('active');
        evt.target.setAttribute('aria-selected', toggleState);
      };
    }
    
  });
});

/* Content Compare */
var contentCompareEles = [].slice.call(document.querySelectorAll('div.content-compare'));
if( contentCompareEles.length > 0 ){

  function initContentCompare() {
    var contentCompares = contentCompareEles.map(function (containerEle) {
      var slider = containerEle;
      var before = containerEle.querySelector('.before');
      var beforeImage = before.getElementsByTagName('img')[0];
      var resizer = containerEle.querySelector('.compare-slider');
      var active = false;
  
      var width = slider.offsetWidth;
      beforeImage.style.width = width + 'px';
    
      //Adjust width of image on resize 
      window.addEventListener('resize', function() {
        width = slider.offsetWidth;
        beforeImage.style.width = width + 'px';
      });
      
      resizer.addEventListener('mousedown',function(){
       active = true;
       resizer.classList.add('resize');
      });
      
      document.body.addEventListener('mouseup',function(){
        active = false;
        resizer.classList.remove('resize');
      });
      
      document.body.addEventListener('mouseleave', function() {
        active = false;
        resizer.classList.remove('resize');
      });
      
      document.body.addEventListener('mousemove',function(e){
        if (!active) return;
        var x = e.pageX;
        x -= slider.getBoundingClientRect().left;
        contentCompareSlide(x);
        contentComparePause(e);
      });
      
      resizer.addEventListener('touchstart',function(){
        active = true;
        resizer.classList.add('resize');
      });
      
      document.body.addEventListener('touchend',function(){
        active = false;
        resizer.classList.remove('resize');
      });
      
      document.body.addEventListener('touchcancel',function(){
        active = false;
        resizer.classList.remove('resize');
      });
      
      //calculation for dragging on touch devices
      document.body.addEventListener('touchmove',function(e){
        if (!active) return;
        var x;
        var i;
        for (i=0; i < e.changedTouches.length; i++) { x = e.changedTouches[i].pageX; }
        x -= slider.getBoundingClientRect().left;
        contentCompareSlide(x);
        contentComparePause(e);
      });
  
      function contentCompareSlide(x){
        var transform = Math.max(0,(Math.min(x,slider.offsetWidth)));
        before.style.width = transform+"px";
        resizer.style.left = transform-0+"px";
      }
      
      //stop divs being selected.
      function contentComparePause(e){
        if(e.stopPropagation) e.stopPropagation();
        if(e.preventDefault) e.preventDefault();
        e.cancelBubble=true;
        e.returnValue=false;
        return false;
      }
    });
  }; //function initContentCompare()
  initContentCompare();
  
}; // if( contentCompareEles.length > 0 )
